import { render, staticRenderFns } from "./AllBubble.vue?vue&type=template&id=03382116&"
import script from "./AllBubble.vue?vue&type=script&lang=js&"
export * from "./AllBubble.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports